import { isNonEmpty } from '@sgme/fp';
import { getFakePermissions, getImpersonatedUser } from 'utils/fakesso/userImpersonation';

import type { IHttpConfig } from '../httpClient.model';
export default (config: IHttpConfig): IHttpConfig => {
  const userToImpersonate = getImpersonatedUser();
  const userPermissionsToImpersonate = getFakePermissions();
  if (userToImpersonate || isNonEmpty(userPermissionsToImpersonate)) {
    const requests = {
      ...config,
      headers: {
        ...config.headers,
      },
    };
    if (userToImpersonate) {
      requests.headers['X-Fake-Authentication'] = userToImpersonate;
    }
    if (isNonEmpty(userPermissionsToImpersonate)) {
      requests.headers['X-Fake-Iam-Permissions'] = userPermissionsToImpersonate;
    }
    return requests;
  } else {
    return config;
  }
};
